module.exports = __webpack_public_path__ + "img/sec2.4.8e2f15f5.png";